import { InputLabel, NativeSelect } from "@mui/material";
import React, { FC } from "react";

interface Participant {
  name: string;
  favoriteRanking: number;
}

interface DelendBankSelectionProps {
  value: Participant[];
  handleChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const DelendBankSelection: FC<DelendBankSelectionProps> = (props) => {
  const buildOptions = (participants: Participant[]) => {
    let endedFavorite = false;

    const selectOption = (
      <option key={"select"} value={"Selecionar"}>
        Selecionar
      </option>
    );

    const options = participants.map((participant) => {
      if (participant.favoriteRanking === 0 && endedFavorite !== true) {
        endedFavorite = true;
        return (
          <React.Fragment key={"separator"}>
            <option value={"separador"}>..........................</option>
            <option value={participant.name}>{participant.name}</option>
          </React.Fragment>
        );
      }

      return (
        <option key={participant.name} value={participant.name}>
          {participant.name}
        </option>
      );
    });

    return [selectOption, ...options];
  };

  return (
    <>
      <InputLabel variant="standard" htmlFor="uncontrolled-native">
        Instituição financeira
      </InputLabel>
      <NativeSelect
        sx={{ width: "100%" }}
        required
        inputProps={{
          name: "brands",
          id: "brands",
        }}
        onChange={props.handleChange}
      >
        {buildOptions(props.value)}
      </NativeSelect>
    </>
  );
};

export default DelendBankSelection;
